import app, { Component } from 'apprun';
import { isValid, lookup_en } from '../utils';

export default class CompanyPropertyComponent extends Component {
    state = { }

    view = (state) => {
      if (!state.item) {return;}
      let award = '', year = '';
      const separator = ' >> ';

      const years =Array(50).fill(5).map((item, index) => 1980 + index);

      if (state.item.value.indexOf(separator) > 0) {
        award = state.item.value.substr(0, state.item.value.indexOf(separator));
        year = state.item.value.replace(award + separator, '');
      } else {
        award = state.item.value;
      }
      return (
        <form id="AwardEditForm" class="form-horizontal" style={{ width: '450px' }}>
          <div class="row">
            <div class="col-sm-12">{state.item.dispName}</div>
            <div class="row">
              <span class="col-sm-9"></span>
              <span class="col-sm-3">Year</span>
            </div>
            <div class="row">
              <span class="col-sm-8">
                <select id="selectedaward" name="award" oninput={e => award = (e.target.options[e.target.selectedIndex].text)} data-validate>
                  <option value=' '>[Select]</option>
                  {lookup_en.AdminCompanyAwards.map(r => <option value={r.id} selected={r.value === award ? 'selected' : null}>{r.value}</option>)}
                </select>
                &nbsp;
              </span>
              <span class="col-sm-3">
                <select id="awardYear" name="awardYear" oninput={e => year = (e.target.options[e.target.selectedIndex].text)} data-validate>
                  <option value=' '>[Select]</option>
                  {years.map(r => <option value={r} selected={r.toString() === year ? 'selected' : null}>{r.toString()}</option>)}
                </select>
                &nbsp;
              </span>
            </div>
            <div class="row">
              <div id="selectedawardErrMsg" class="text-danger col-sm-9"></div>
              <div id="awardYearErrMsg" class="text-danger col-sm-3"></div>
            </div>
          </div>
          <div class="edit-buttons">
            <a
              type="button"
              class="btn btn-primary btn-xs"
              style={(state.item.required || (state.item.value===''))?{ display:'none' }:{ display:'inline-block' }}
              onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
            </a>
            <a
              type="button"
              class="btn btn-primary btn-xs"
              onclick={e => this.run('save', e, award, year)}>
            save
            </a>
            <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('cancel')}>
            cancel
            </a>
          </div>
        </form>
      );
    };

  update = {

    save: (state, e, award, year) => {
      state.newVal = award + ' >> ' + year;
      if(!isValid('AwardEditForm')) { e.preventDefault(); return;}
      state.caller.run(state.save, state.item, state.panelId, state.newVal);
    },

    cancel: (state) => {
      state.caller.run(state.cancel, state.panelId);
    },
  }

  mounted = ({ state }) => state;
}
